import React from 'react';
import { Link } from 'react-router-dom';
import './Footer.css';

function Footer() {
  return (
    <footer className="va-footer">
      <div className="footer-content">

        {/* Navigation + Legal */}
        <div className="footer-section">
          <h4>Navigation</h4>
          <ul>
            <li><Link to="/">Home</Link></li>
            <li><Link to="/tournaments">Tournaments</Link></li>
            <li><Link to="/games">Games</Link></li>
            <li><Link to="/versus-token">Versus Token</Link></li>
            <li><Link to="/shop">Shop</Link></li>
          </ul>
        </div>

        <div className="footer-section">
          <h4>Brand</h4>
          <ul>
            <li><Link to="/downloads">Downloads</Link></li>
          </ul>
        </div>

        <div className="footer-section">
          <h4>Legal & Support</h4>
          <ul>
            <li><Link to="/imprint">Imprint</Link></li>
            <li><Link to="/privacy">Privacy Policy</Link></li>
            <li><Link to="/terms">Terms & Conditions</Link></li>
            <li><Link to="/faq">FAQ</Link></li>
            <li><a href="mailto:info@versus-arena.com">Support</a></li>
          </ul>
        </div>

        {/* Socials */}
        <div className="footer-section">
          <h4>Follow Us</h4>
          <ul className="social-links">
            <li>
              <a href="https://www.instagram.com/theversusarena/" target="_blank" rel="noreferrer">
                Instagram
              </a>
            </li>
            <li>
              <a href="https://x.com/theversusarena" target="_blank" rel="noreferrer">
                X (Twitter)
              </a>
            </li>
            <li>
              <a href="https://t.me/Versusarenaentry_bot" target="_blank" rel="noreferrer">
                Telegram
              </a>
            </li>
          </ul>
        </div>

      </div>

      {/* Copyright */}
      <div className="footer-bottom">
        <p>&copy; {new Date().getFullYear()} Versus Arena. All Rights Reserved.</p>
      </div>
    </footer>
  );
}

export default Footer;